import { Component } from '@angular/core';
import { SidebarComponent } from '../shared/common-components/sidebar/sidebar.component';
import { HeaderComponent } from '../shared/common-components/header/header.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [SidebarComponent, HeaderComponent],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {}
